module.exports = __webpack_public_path__ + "img/battery_4disable.e7769bdb.png";